import { replaceChildrenWithClones } from "../../../helpers/replaceChildrenWithClones";

export default [
    {
        key: "stol__pst",
        extra: (el) => {
            replaceChildrenWithClones(el); // TODO КОСТЫЛЬ
        },
    },
    {
        key: "ruchka",
        allArray: "allRuchkaSP",
        activeArray: "activeRuchkaSP",
        position: "bottom",
    },
];
